import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

// Handles real-time comment updates via ActionCable
export default class extends Controller {
  static values = { 
    commentableType: String, 
    commentableId: Number 
  }

  connect() {
    console.log("Comments stream controller connected")
    this.setupChannel()
  }

  disconnect() {
    if (this.channel) {
      this.channel.unsubscribe()
    }
  }

  setupChannel() {
    const consumer = createConsumer()
    
    this.channel = consumer.subscriptions.create(
      { 
        channel: "CommentsChannel",
        commentable_type: this.commentableTypeValue,
        commentable_id: this.commentableIdValue
      },
      {
        connected() {
          console.log("Connected to comments channel")
        },

        disconnected() {
          console.log("Disconnected from comments channel")
        },

        received(data) {
          console.log("Received comment update:", data)
          
          // Handle different action types
          switch(data.action) {
            case 'comment_created':
              this.handleCommentCreated(data)
              break
            case 'comment_updated':
              this.handleCommentUpdated(data)
              break
            case 'comment_deleted':
              this.handleCommentDeleted(data)
              break
          }
        },

        handleCommentCreated(data) {
          // Turbo will handle the stream update
          // We can add additional client-side effects here if needed
          
          // Show a notification
          if (data.user_id !== window.currentUserId) {
            this.showNotification("New comment added")
          }
        },

        handleCommentUpdated(data) {
          // Handle comment updates
        },

        handleCommentDeleted(data) {
          // Handle comment deletion
        },

        showNotification(message) {
          // Create a temporary notification
          const notification = document.createElement('div')
          notification.className = 'fixed bottom-4 right-4 bg-blue-500 text-white px-4 py-2 rounded-lg shadow-lg z-50 animate-fade-in'
          notification.textContent = message
          document.body.appendChild(notification)
          
          setTimeout(() => {
            notification.classList.add('animate-fade-out')
            setTimeout(() => notification.remove(), 300)
          }, 3000)
        }
      }
    )
  }
}